<script>

    import Main from '../requests/main.svelte'
    import Prices from '../requests/prices.svelte'

    let step = 'main'
    let mainData = {}
    let quotation = {}

    function quotationSuccess() {
        step = 'prices'
    }

    function onStep(event) {
        step = event.detail
    }

</script>

<style>

    .body {
        height: 100vh;
        overflow-y: scroll;
    }

    .centerContent {
        display: flex;
        justify-content: center;
    }
    .content {
        background: white;
        padding: 32px;
        border-radius: 16px;
        min-width: 30vw;
    }

</style>

<div class="body">
    <div class="centerContent">
        <div class="content space bottom top">
            {#if step === 'main'}
                <Main on:success={ quotationSuccess } on:step={onStep} bind:quotation={quotation} bind:data={mainData} findQuotations />
            {:else if step === 'prices'}
                <Prices on:step={onStep} {quotation} />
            {/if}
        </div>
    </div>
</div>